<template>
  <section class="section-product-detail-page bg-grey">
    <div class="container">
      <div class="row m-0">
        <div class="col-12">
          <div class="content py-0">
            <h2 class="section-title page-title h2 text-center text-black f-44 h2-caslon">Thank You</h2>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-primary">
    <div class="container">
      <div class="page-content">
        <div class="content">
          <div class="content">
            <h1 class="who-we-are-text text-white ff-caslon-pro f-44 fw-600">Who We Are?</h1>
          </div>

          <ContentsTextWithImage
              image-url="/pages/products/about-nagase/Screen-Shot-2565-05-05-at-12.45.17-1.png"
              :contents="[
              'NAGASE & CO., LTD. is a chemical trading firm, founded in Kyoto, Japan in 1832. The NAGASE Group began as a specialized sales agent securing exclusive contracts to sell industry-leading products from around the world in Japan. Over the years, we have leveraged our technology and information gathering expertise —as well as our global network—to transform our business into a hybrid model offering superior manufacturing, processing, and R&D functions as well as trading company services. Looking forward to our 200th anniversary in the year 2032, we are creating a platform for sustainable growth.',
            ]"
              is-reverse="true"
              is-white-content="true"
              is-remove-divider="true"
              is-content-small-text="true"
              left-width="39.735%"
              right-width="60.265%"
          />

        </div>
      </div>
    </div>
  </section>

  <!-- SECTION GROUP NETWORK -->
  <section class="section-group-network">
    <div class="container">
      <div class="content">

        <div class="row m-0">

          <div class="col-12 col-md-4 p-0">
            <div class="content">
              <h2 class="group-network-title">See NAGASE Group Network Here</h2>
              <div class="section-divider ms-0" style="width: 75px;  "></div>
            </div>
          </div>

          <div class="col-12 col-md-4 p-0">
            <div class="content">
              <!-- GROUP NETWORK ITEM -->
              <a href="https://www.nagase.co.jp/english/company/group/europe/" class="group-network-item">
                <img src="/pages/products/about-nagase/map01.jpg" alt="NAGASE Group Network - Europe">
                <span>Europe</span>
              </a>
              <!-- GROUP NETWORK ITEM -->
            </div>
          </div>

          <div class="col-12 col-md-4 p-0 pb-1">
            <div class="content">
              <!-- GROUP NETWORK ITEM -->
              <a href="https://www.nagase.co.jp/english/company/group/northeast-asia/" class="group-network-item">
                <img src="/pages/products/about-nagase/map02.jpg" alt="NAGASE Group Network - Greater China & Korea">
                <span>Greater China & Korea</span>
              </a>
              <!-- GROUP NETWORK ITEM -->
            </div>
          </div>

          <div class="col-12 col-md-4 p-0">
            <div class="content">
              <!-- GROUP NETWORK ITEM -->
              <a href="https://www.nagase.co.jp/english/company/group/america/" class="group-network-item">
                <img src="/pages/products/about-nagase/map03.jpg" alt="NAGASE Group Network - Americas">
                <span>Americas</span>
              </a>
              <!-- GROUP NETWORK ITEM -->
            </div>
          </div>

          <div class="col-12 col-md-4 p-0">
            <div class="content">
              <!-- GROUP NETWORK ITEM -->
              <a href="https://www.nagase.co.jp/english/company/group/other-asia/" class="group-network-item">
                <img src="/pages/products/about-nagase/map04.jpg" alt="NAGASE Group Network - ASEAN & The Middle East">
                <span>ASEAN & The Middle East</span>
              </a>
              <!-- GROUP NETWORK ITEM -->
            </div>
          </div>

          <div class="col-12 col-md-4 p-0">
            <div class="content">
              <!-- GROUP NETWORK ITEM -->
              <a href="https://www.nagase.co.jp/english/company/group/domestic/" class="group-network-item">
                <img src="/pages/products/about-nagase/map05.jpg" alt="NAGASE Group Network - Japan">
                <span>Japan</span>
              </a>
              <!-- GROUP NETWORK ITEM -->
            </div>
          </div>

        </div>

      </div>
    </div>
  </section>
  <!-- SECTION GROUP NETWORK -->
  <section>
    <div class="container">
      <div class="content pb-5  mb-5" style="margin-top: -15px">
        <h2 class="group-network-title" style="margin-bottom: 50px; font-size: 1.76rem">History of NAGASE THAILAND</h2>
        <div class="section-divider ms-0 " style="width: 80px;  "></div>

        <!-- Paragraph tags -->
        <p style="font-size: 13.5px;margin-top: -10px">Nagase (Thailand) Co., Ltd performs as distributor and trading
                                                       company consisting of 5 business units Plastics, Functional
                                                       Material, Packaging Products, Automotive, Life & Healthcare
                                                       Products (Link to each website) We support market intelligence,
                                                       trading transactions and logistics operations among global
                                                       customers and suppliers in Thailand leading industries for more
                                                       than 30 years</p>
        <!-- Paragraph tags -->

        <p class="play-text"><img src="/pages/products/about-nagase/play_button.png" alt="Timeline marker"><strong
            class="text-primary"> 1987 </strong> Start up the Representative in Bangkok @ Wall street Tower</p>
        <p class="play-text"><img src="/pages/products/about-nagase/play_button.png" alt="Timeline marker"><strong
            class="text-primary"> 1989 </strong> Mar 31’89 , Start to operate Nagase (Thailand) Co.,Ltd. Chemical Divi.
                                                 / GE Div. / Plastic & Machinery Div. / Finance Div. with 6M paid up
                                                 capital</p>
        <p class="play-text"><img src="/pages/products/about-nagase/play_button.png" alt="Timeline marker"><strong
            class="text-primary"> 1990 </strong> Move office to Thaniya Plaza</p>
        <p class="play-text"><img src="/pages/products/about-nagase/play_button.png" alt="Timeline marker"><strong
            class="text-primary"> 1995 </strong> Increase capital to be 12 M. THB. paid up capital</p>
        <p class="play-text"><img src="/pages/products/about-nagase/play_button.png" alt="Timeline marker"><strong
            class="text-primary"> 1999 </strong> Celebrated 10 Years Anniversary</p>
        <p class="play-text"><img src="/pages/products/about-nagase/play_button.png" alt="Timeline marker"><strong
            class="text-primary"> 2000 </strong> Increase capital to be 300M. THB. paid up capital Establish Nagase
                                                 (Siam) Co.,Ltd.</p>
        <p class="play-text"><img src="/pages/products/about-nagase/play_button.png" alt="Timeline marker"><strong
            class="text-primary"> 2001 </strong> Open branch at Sriracha , Chonburi by Nagase (Siam)</p>
        <p class="play-text"><img src="/pages/products/about-nagase/play_button.png" alt="Timeline marker"><strong
            class="text-primary"> 2004 </strong> Move office to Ramaland Building</p>
        <p class="play-text"><img src="/pages/products/about-nagase/play_button.png" alt="Timeline marker"><strong
            class="text-primary"> 2009 </strong> Celebrated 20 Years Anniversary</p>
        <p class="play-text"><img src="/pages/products/about-nagase/play_button.png" alt="Timeline marker"><strong
            class="text-primary"> 2011 </strong> Increase paid-up capital to be 321M. THB. Sriracha office became NTL
                                                 Eastern office</p>
        <p class="play-text"><img src="/pages/products/about-nagase/play_button.png" alt="Timeline marker"><strong
            class="text-primary"> 2012 </strong> Start business of Hayashibara product in NTL Move eastern office to
                                                 Harbor Mall</p>
        <p class="play-text"><img src="/pages/products/about-nagase/play_button.png" alt="Timeline marker"><strong
            class="text-primary"> 2016 </strong> Increase paid-up capital to be 321M. THB. Sriracha office became NTL
                                                 Eastern office</p>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
useHead({
  title: 'Thank you - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.page-title {
  padding-bottom: 40px;
}

.play-text {
  font-size: 13.5px;
  margin: 5px;
  margin-left: 10px;
}

.who-we-are-text {
  margin: 30px 0;
}
</style>
